import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["removeButton", "selectAllCheckbox", "itemCheckbox", "form"]

  connect() {
    this.hideRemoveButton()
  }

  // Handle remove button click with dynamic confirmation
  removeSelected(event) {
    event.preventDefault()

    const checkedCount = this.checkedItems.length
    const categoryName = this.removeButtonTarget.dataset.categoryName
    const objectType = this.removeButtonTarget.dataset.objectType
    const pluralizedObject = this.pluralizeObject(checkedCount)

    const confirmMessage = `Wyłączasz widoczność ${checkedCount} ${pluralizedObject} (${objectType}) w kategorii ${categoryName}. Czy na pewno chcesz to zrobić?`

    if (confirm(confirmMessage)) {
      this.submitFormWithAjax()
    }
  }

  // Handle "Select All" checkbox
  toggleSelectAll(event) {
    const isChecked = event.target.checked

    this.itemCheckboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })

    this.updateRemoveButtonVisibility()
  }

  // Handle individual checkbox change
  toggleItem(event) {
    this.updateSelectAllState()
    this.updateRemoveButtonVisibility()
  }

  // Private methods
  updateSelectAllState() {
    const allCheckboxes = this.itemCheckboxTargets
    const checkedCheckboxes = this.checkedItems

    if (checkedCheckboxes.length === allCheckboxes.length) {
      // All checked
      this.selectAllCheckboxTarget.checked = true
      this.selectAllCheckboxTarget.indeterminate = false
    } else if (checkedCheckboxes.length > 0) {
      // Some checked
      this.selectAllCheckboxTarget.checked = false
      this.selectAllCheckboxTarget.indeterminate = true
    } else {
      // None checked
      this.selectAllCheckboxTarget.checked = false
      this.selectAllCheckboxTarget.indeterminate = false
    }
  }

  updateRemoveButtonVisibility() {
    if (this.checkedItems.length > 0) {
      this.showRemoveButton()
    } else {
      this.hideRemoveButton()
    }
  }

  showRemoveButton() {
    this.removeButtonTarget.style.display = 'block'
  }

  hideRemoveButton() {
    this.removeButtonTarget.style.display = 'none'
  }

  pluralizeObject(count) {
    return count === 1 ? "obiektu" : "obiektów"
  }

  get checkedItems() {
    return this.itemCheckboxTargets.filter(checkbox => checkbox.checked)
  }

  submitFormWithAjax() {
    const formData = new FormData(this.formTarget)

    fetch(this.formTarget.action, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': this.getCSRFToken(),
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      }
    })
  }

  getCSRFToken() {
    const token = document.querySelector('[name="csrf-token"]')
    return token ? token.content : ''
  }
}
